/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Fireblocks asset DTO
 */
export interface FireblocksAssetDto {
  id?: number;
  externalAssetName?: string;
  fullName?: string;
  type?: string;
  contractAddress?: string;
  assetId?: number;
  asset?: Asset;
  network?: string;
  feeLevel?: FireblocksAssetDto.FeeLevelEnum;
  customLevel?: number;
  keepMinAmountDuringSweep?: number;
  feeAssetMapId?: number;
  minSweepAmount?: number;
  fuelMoveSize?: number;
  ignore?: boolean;
  businessEntity?: FireblocksAssetDto.BusinessEntityEnum;
  deprecatedInFireblocks?: boolean;
}
export namespace FireblocksAssetDto {
  export const FeeLevelEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Custom: 'CUSTOM',
  } as const;
  export type FeeLevelEnum = (typeof FeeLevelEnum)[keyof typeof FeeLevelEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
